import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { ProductRequest } from "../../../../../apis/product/ProductRequest";

const GetProductScrapedCode = (code?: string) => {
  const params: { code: string } = useParams();
  const { data, isLoading } = useQuery(
    ["GetProductScrapedCode"],
    () => ProductRequest.getProductScrapedCode(code ? code : params.code),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    }
  );

  return {
    data,
    isLoading,
  };
};

export default GetProductScrapedCode;
